import * as yup from 'yup';
import { emailExists, getFederatedLoginConfigByEmail } from '@domain/auth/auth-service';
import { ERROR_MESSAGES } from '@shared/constants/validation.constants';
import { validateEmail } from '@shared/utils/validation.utils';

export const usernameSchema = yup
    .string()
    .test('isNotEmail', ERROR_MESSAGES.INVALID_EMAIL, validateEmail)
    .test('checkEmail', ERROR_MESSAGES.DUPLICATE_EMAIL, (email: string) => emailExists(email).then((res: boolean) => !res))
    .test('federatedEmail', ERROR_MESSAGES.FEDERATED_EMAIL, async (email: string) => {
        const federatedLoginConfig = await getFederatedLoginConfigByEmail(email);
        return !federatedLoginConfig;
    })
    .email(ERROR_MESSAGES.INVALID_EMAIL)
    .required(ERROR_MESSAGES.REQUIRED_EMAIL);

export const inviteeEmailSchema = yup
    .string()
    .test('isNotEmail', ERROR_MESSAGES.INVALID_EMAIL, validateEmail)
    .test('checkEmail', ERROR_MESSAGES.DUPLICATE_EMAIL, (email: string) => emailExists(email).then((res: boolean) => !res))
    .email(ERROR_MESSAGES.INVALID_EMAIL)
    .required(ERROR_MESSAGES.REQUIRED_EMAIL);
